import { atom } from 'jotai';
export const $UserAgent = atom({
    userAgent: '',
    isMobile: false,
    isBot: false,
    isiOS: false,
    isSafari: false,
    isInApp: false,
    isMacOS: false,
    isInTikTokApp: false,
});
$UserAgent.debugLabel = '$UserAgent';
